/** Canonical directory SRP URL: path plus optional `?page=N` when N is greater than 1. */
export function buildDirectoryCanonicalUrl(path: string, currentPage: number): string {
  const pageQuery = currentPage > 1 ? `?page=${currentPage}` : '';
  return `${import.meta.env.VUE_APP_BASE_URL}${path}${pageQuery}`;
}
